// Module
var code = "<template>\n  <div class=\"loader\" class.bind=\"dark ? 'dark' : ''\"></div>\n</template>\n";
// Exports
export default code;